/* Source: /home/sidsolaiyappan/skooch_ai/shared/week_dates.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
function isoDateOf(d) {
  let _y = d.getFullYear();
  let _m = (d.getMonth() + 1);
  let _dd = d.getDate();
  let _ms = ((_m < 10) ? ("0" + String(_m)) : String(_m));
  let _ds = ((_dd < 10) ? ("0" + String(_dd)) : String(_dd));
  return ((((String(_y) + "-") + _ms) + "-") + _ds);
}
function computeWeekInfo(weekOffset) {
  let _MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  let _DAY_NAMES = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  let _now = Reflect.construct(Date, []);
  let _today = _now.getDay();
  let _mondayOffset = ((_today + 6) % 7);
  let _weekStart = Reflect.construct(Date, [_now.getFullYear(), _now.getMonth(), ((_now.getDate() - _mondayOffset) + (weekOffset * 7))]);
  let _weekEnd = Reflect.construct(Date, [_weekStart.getFullYear(), _weekStart.getMonth(), (_weekStart.getDate() + 6)]);
  let _weekLabel = ((((((("Monday, " + _MONTHS.at(_weekStart.getMonth())) + " ") + String(_weekStart.getDate())) + " - Sunday, ") + _MONTHS.at(_weekEnd.getMonth())) + " ") + String(_weekEnd.getDate()));
  let _dayDates = [0, 1, 2, 3, 4, 5, 6].map(i => String(Reflect.construct(Date, [_weekStart.getFullYear(), _weekStart.getMonth(), (_weekStart.getDate() + i)]).getDate()));
  let _weekIsoDays = [0, 1, 2, 3, 4, 5, 6].map(i => isoDateOf(Reflect.construct(Date, [_weekStart.getFullYear(), _weekStart.getMonth(), (_weekStart.getDate() + i)])));
  let _todayDate = Reflect.construct(Date, [_now.getFullYear(), _now.getMonth(), _now.getDate()]);
  let _isCurrentWeek = ((_weekStart.getTime() <= _todayDate.getTime()) && (_todayDate.getTime() < (_weekStart.getTime() + ((((7 * 24) * 60) * 60) * 1000))));
  let _todayIdx = ((_today + 6) % 7);
  return {"weekStart": _weekStart, "weekEnd": _weekEnd, "weekLabel": _weekLabel, "dayDates": _dayDates, "weekIsoDays": _weekIsoDays, "dayNames": _DAY_NAMES, "isCurrentWeek": _isCurrentWeek, "todayIdx": _todayIdx};
}
export {computeWeekInfo, isoDateOf};
//# sourceMappingURL=week_dates.js.map
